<template>
    <div class="notice" v-if="noticeText.length">
        直播间公告：{{noticeText}}
    </div>
</template>

<script>
export default {
  props: {
    noticeText: {}
  },
  data () {},
  methods: {

  },
  computed: {}
}
</script>
<style type="scss" scoped>
    .notice {
        background: rgba(0, 0, 0, 0.25);
        border-radius: 0.84375rem;
        border-radius: 0.84375rem;
        padding: 0.50625rem;
        font-family: PingFangSC-Medium;
        font-size: 0.7rem;
        color: #f9fffe;
        letter-spacing: 0;
        line-height: 0.84375rem;
    }
</style>
